module.exports = __webpack_public_path__ + "static/fortinet-resource-tile-b0d7e9816ed634631372e6bea7f05571.jpg";